import React from "react";

const CheckboxSmallWithoutLabel = ({
  id,
  name,
  value,
  error,
  checked,
  onChange,
}) => {
  return (
    <div>
      <input
        type="checkbox"
        className="w-4 h-4 p-0 m-0 accent-[#AB3C1B]"
        name={`${name}`}
        id={`${id}`}
        value={`${value}`}
        checked={checked}
        // defaultChecked={checked}
        onChange={onChange}
      />
      <div className="h-2">
        <label
          htmlFor={id}
          className="font-normal text-[0.75rem] text-red-500 bg-white  pt-1 my-0 py-0 font"
        >
          {error}
        </label>
      </div>
    </div>
  );
};

export default CheckboxSmallWithoutLabel;
